import React, { Component, Fragment } from 'react';
import { Label, Row, Col, Input, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import 'bootstrap/dist/css/bootstrap.css';

class CustomerInfoListing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientId: parseInt(this.props.selector) > 0 ? this.props.selector : 0,
            data: [],
            info: [],
            services: [],
            sheetData: [],
            clientList: this.props.filterClients()
        };
        this.headers = [
            { display: 'Name', accessors: ['name'] },
            { display: 'Team', accessors: ['team'] },
            { display: 'Account Owner Name', accessors: ['primaryFirstName', 'primaryLastName'] },
            { display: 'Account Owner Email', accessors: ['primaryEmail'] },
            { display: 'Account Owner Job Title', accessors: ['primaryJobTitle'] },
            { display: 'Processor Name', accessors: ['processorFirstName', 'processorLastName'] },
            { display: 'Processor Email', accessors: ['processorEmail'] },
            { display: 'Processor Job Title', accessors: ['processorJobTitle'] },
            { display: 'Backup Name', accessors: ['secondaryFirstName', 'secondaryLastName'] },
            { display: 'Backup Email', accessors: ['secondaryEmail'] },
            { display: 'Backup Job Title', accessors: ['secondaryJobTitle'] },
        ];
    }

    componentDidMount() {
        this.props.log('CustomerInfoListing.js/componentDidMount');
        if (this.state.clientId > 0) this.onSubmit();
        this.props.filterClientsCallback(() => {
            this.setState({
                clientList: this.props.filterClients()
            })
        });
    }

    onSubmit = () => {
        this.props.info('CustomerInfoListing.js/onSubmit');
        fetch('/api/reports/CustomerInfoListing', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
                { key: 'clientId', type: 'int', value: this.state.clientId },
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        data: results.data,
                        info: JSON.parse(results.data[0].info),
                        services: JSON.parse(results.data[0].services).filter(service => service.services != null)
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getCSVdata = () => {
        this.props.info('CustomerInfoListing.js/getCSVdata');
        let retArray = [[], []];
        const newArr = this.state.services != null ? this.state.services/*.filter(service => service.services != null)*/.map(service => {
            return ({
                name: service.name, headers: service.headers.split(',').map(item => item === '' ? null : item), sections: (service.services != null) ? service.services.filter(section => section.fields != null).map(section => {
                    return ({
                        fields: section.fields.map(field => {
                            return ({ classNames: '', col: 0, hint: field.column, inputMask: '', name: field.section, type: (field.type != null ? field.type : 'text'), validation: '' })
                        }), limit: section.limit, name: section.name, stateSection: section.section
                    })
                }) : []
            })
        }).sort((a, b) => a.name.localeCompare(b.name)) : null;
        this.headers.forEach(field => {
            if (field.accessors.map(accessor => this.state.data[0][accessor]).join(' ').trim() !== '')
                retArray[0].push(field.display);
        })
        this.headers.forEach(field => {
            if (field.accessors.map(accessor => this.state.data[0][accessor]).join(' ').trim() !== '')
                retArray[1].push(field.accessors.map(accessor => this.state.data[0][accessor]).join(' '));
        })
        this.props.companySchema.parents.forEach((parent) => {
            const sections = parent.sections.map(section => section.stateSection);
            if (this.state.info != null) {
                const infoSections = Object.keys(this.state.info);
                const filteredArray = sections.filter(value => infoSections.includes(value));
                if (filteredArray.length > 0) retArray.push([], [parent.name]);
                if (parent.headers != null && parent.sections.filter(section => this.state.info[section.stateSection] != null).length > 0) {
                    let row = [];
                    parent.headers.forEach((header) => row.push(header))
                    retArray.push([], row);
                }
                parent.sections.forEach((section) => {
                    if (this.state.info[section.stateSection] != null) {
                        this.state.info[section.stateSection].forEach((entry) => {
                            let row = [];
                            if (parent.headers != null && parent.headers[0] == null) row.push(section.name);
                            section.fields.forEach((field, fieldIndex) => row.push(this.parseType(entry[field.name], section.fields[fieldIndex].type)));
                            retArray.push(row);
                        })
                    }
                })
            }
        });

        newArr.forEach((parent) => {
            const sections = parent.sections.map(section => section.stateSection);
            if (this.state.info != null) {
                const infoSections = this.state.info != null ? Object.keys(this.state.info) : [];
                const filteredArray = sections.filter(value => infoSections.includes(value));
                if (filteredArray.length > 0) { retArray.push(['']); retArray.push([parent.name]); retArray.push(['']); }
                let row = [];
                if (parent.headers != null && parent.sections.filter(section => this.state.info[section.stateSection] != null).length > 0) {
                    if (parent.headers.filter(header => header != null).length > 0) {
                        parent.headers.filter(header => header != null).forEach((header) => {
                            row.push(header);
                        })
                    } else {
                        row.push('Service');
                    }
                    // } else {
                    if (parent.sections != null && parent.sections.length > 0 && parent.sections[0].fields != null) {
                        parent.sections[0].fields.forEach(field => {
                            row.push(field.hint);
                        })
                    }
                }
                retArray.push(row);
                parent.sections.forEach((section) => {
                    if (this.state.info[section.stateSection] != null) {
                        row = [];
                        this.state.info[section.stateSection].forEach((entry, entryIndex) => {
                            if (parent.headers != null && parent.headers[0] == null) {
                                row.push(section.name);
                            } else {
                                row.push('')
                            }
                            section.fields.forEach((field, fieldIndex) => {
                                row.push(this.formatText(entry[field.name], section.fields[fieldIndex].type));
                            })
                        })
                        retArray.push(row);
                        // retArray.push(['']);
                    }
                });
            }
        })
        // console.log('rt',retArray);
        // this.setState({ sheetData: retArray })
        this.props.passData(retArray, "customer-info-listing_" + this.state.data[0].name.replace(' ', '-'));
        // return retArray;
    }

    formatText = (val, type) => {
        this.props.info('CustomerInfoListing.js/formatText (val, type)', val, type);
        if (val === '' || val == null) return '';
        // this.props.log('ClientInfo.js/formatText (val,type)', val, type);
        switch (type) {
            case "currency":
                return '$' + parseFloat(val).toFixed(2);
            case "time":
                return this.formatAMPM(val);
            case "checkbox":
                return (val) ? <FontAwesomeIcon icon={faCheck} /> : <></>;
            case "phone":
                var cleaned = ('' + val).replace(/\D/g, '');
                var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
                if (match) return <span className="timerLine">{'(' + match[1] + ') ' + match[2] + '-' + match[3]}</span>;
                return null;
            default:
                return val;
        }
    }

    formatAMPM = (date) => {
        this.props.info('CustomerInfoListing.js/formatAMPM (date)', date);
        if (date === '' || date == null) return date;
        var [hours, minutes] = date.split(':').map(item => parseInt(item));
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    parseType = (str, type) => {
        this.props.info('CustomerInfoListing.js/parseType (str, type)', str, type);
        switch (type) {
            case "time":
                return this.tConvert(str);
            default:
                return str;
        }
    }

    tConvert = (time) => {
        this.props.info('CustomerInfoListing.js/tConvert (time)', time);
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) { // If time format correct
            time = time.slice(1);  // Remove full string match value
            time[5] = +time[0] < 12 ? 'am' : 'pm'; // Set AM/PM
            time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(''); // return adjusted time or original string
    }

    onChange = (e) => {
        this.props.log('CustomerInfoListing.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.props.changeSelector(e);
        this.setState({ clientId: e.target.value }, () => this.onSubmit())
    }

    render() {
        this.props.info('CustomerInfoListing.js/render');
        const newArr = this.state.services != null ? this.state.services/*.filter(service => service.services != null)*/.map(service => {
            return ({
                name: service.name, headers: service.headers.split(',').map(item => item === '' ? null : item), sections: (service.services != null) ? service.services.filter(section => section.fields != null).map(section => {
                    return ({
                        fields: section.fields.map(field => {
                            return ({ classNames: '', col: 0, hint: field.column, inputMask: '', name: field.section, type: (field.type != null ? field.type : 'text'), validation: '' })
                        }), limit: section.limit, name: section.name, stateSection: section.section
                    })
                }) : []
            })
        }).sort((a, b) => a.name.localeCompare(b.name)) : null;
        return (
            <><Row className="mb-4">
                <Col md={12} className="px-1 noPrint">
                    <Label>Company
                        <Input type="select" className="companySelect" name="clientId" value={this.props.isFieldNull(this.state.clientId)} onChange={this.onChange}>
                            <option value="0">Select</option>
                            {this.state.clientList.filter(client => client.active).map(client => (
                                <option key={client.id} value={this.props.isFieldNull(client.id)}>{client.client}</option>
                            ))}
                        </Input>
                    </Label>
                </Col>
            </Row>
                {this.state.data.length > 0 ?
                    <><Row><h2>{this.state.data[0].name}</h2></Row>
                        <Row>
                            <Table>
                                <thead>
                                    <tr>
                                        {this.headers.map((field, fieldIndex) => (
                                            <Fragment key={fieldIndex}>{field.accessors.map(accessor => this.state.data[0][accessor]).join(' ').trim() !== '' ?
                                                <th className="font-weight-bold">{field.display}</th>
                                                : <></>}
                                            </Fragment>
                                        ))
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {this.headers.map((field, fieldIndex) => (
                                            <Fragment key={fieldIndex}>{field.accessors.map(accessor => this.state.data[0][accessor]).join(' ').trim() !== '' ?

                                                <td>{field.accessors.map(accessor => this.state.data[0][accessor]).join(' ')}</td>
                                                : <></>}
                                            </Fragment>
                                        ))
                                        }
                                    </tr>
                                </tbody>
                            </Table>
                            {newArr.forEach((parent, parentIndex) => {
                                const sections = parent.sections.map(section => section.stateSection);
                                if (this.state.info != null) {
                                    const infoSections = this.state.info != null ? Object.keys(this.state.info) : [];
                                    const filteredArray = sections.filter(value => infoSections.includes(value));
                                    let totalColumns = Math.max(...parent.sections.filter(section => this.state.info[section.stateSection] != null).map(section => section.fields.length));
                                    return (
                                        <>
                                            {filteredArray.length > 0 ? <h3 className="mt-4">{parent.name}</h3> : <></>}
                                            <Table>
                                                {parent.headers != null && parent.sections.filter(section => this.state.info[section.stateSection] != null).length > 0 ?
                                                    <thead>
                                                        <tr>
                                                            {parent.headers.filter(header => header != null).length > 0 ? <><th>Service</th>{parent.headers.filter(header => header != null).map((header, headerIndex) => (
                                                                <th className="text-left px-1" key={parentIndex + '--' + headerIndex}>{header}</th>
                                                            ))}</> : <><th>Service</th>
                                                                {parent.sections != null && parent.sections.length > 0 && parent.sections[0].fields != null ?
                                                                    parent.sections[0].fields.map((field, fieldIndex) => (
                                                                        <th key={fieldIndex}>{field.hint}</th>
                                                                    ))
                                                                    : <></>}
                                                            </>}
                                                        </tr>
                                                    </thead>
                                                    : <></>}
                                                {parent.sections.map((section) => (
                                                    <Fragment key={'parent-' + section.id}>{this.state.info[section.stateSection] != null ? this.state.info[section.stateSection].map((entry, entryIndex) => (
                                                        <tr key={entryIndex}>
                                                            <>
                                                                <td>{section.name}</td>
                                                                {section.fields.map((field, fieldIndex) => (
                                                                    <td key={fieldIndex} className={field.classNames + ' text-left px-1'}>
                                                                        {this.formatText(entry[field.name], section.fields[fieldIndex].type)}
                                                                    </td>
                                                                ))}
                                                                {[...Array(totalColumns - section.fields.length).keys()].map((item, itemIndex) => (<td key={itemIndex}>&nbsp;</td>))}
                                                            </>
                                                        </tr>
                                                    )) : <></>}</Fragment>
                                                ))}
                                            </Table>
                                        </>
                                    )
                                }
                            })}
                        </Row>
                        {/* <Row>
                            <CSVLink
                                className="btn btn-primary"
                                data={this.getCSVdata()}
                                filename={"rbo-report_customer-info-listing_" + this.state.data[0].name.replace(' ', '-') + ".csv"}
                            >Download CSV</CSVLink>
                        </Row> */}
                    </>
                    : <>No results</>}
            </>
        );

    }
}

export default CustomerInfoListing;
